import {Select} from "@ui";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import useListContacts from "../../../hooks/contacts/useListContacts.hook";

const TransferUserId = ({selectedContact, setSelectedContact, setIsNextDisabled}) => {
  const {contacts, isSuccess, isError} = useListContacts();
  const {t} = useTranslation();

  // Set default value to undefined so placeholder is shown until user selects
  const selectValue = selectedContact?.id || undefined;

  // Responsive select width with useEffect
  const [responsiveWidth, setResponsiveWidth] = useState(
    typeof window !== "undefined" && window.matchMedia("(max-width: 650px)").matches ? 300 : 558
  );
  const [isMobile, setIsMobile] = useState(typeof window !== "undefined" && window.innerWidth <= 768);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    const mediaQuery = window.matchMedia("(max-width: 650px)");
    const handleResize = () => {
      setResponsiveWidth(mediaQuery.matches ? 300 : 558);
      setIsMobile(window.innerWidth <= 768);
    };
    mediaQuery.addEventListener("change", handleResize);
    window.addEventListener("resize", handleResize);
    return () => {
      mediaQuery.removeEventListener("change", handleResize);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Remove auto-select logic from useEffect
  useEffect(() => {
    if (!selectedContact) {
      setIsNextDisabled?.(true);
    }
  }, [selectedContact, setIsNextDisabled]);

  // Disable Next button until a contact is chosen
  const handleSelectChange = contactId => {
    if (!contactId) {
      setSelectedContact(null);
      setIsNextDisabled?.(true);
      return;
    }
    const contact = contacts.find(c => c.contact_id === contactId);
    setSelectedContact({id: contact.contact_id, name: contact.name});
    setIsNextDisabled?.(false);
  };

  if (isError) {
    return <div>{t("transferSteps_loadingError")}</div>;
  }

  if (!isSuccess) {
    return <div>{t("transferSteps_loading")}</div>;
  }

  return (
    <div>
      {isMobile && (
        <style>
          {`
            .transfer-user-mobile-select.ant-select .ant-select-selector {
              padding: 0 12px !important;
              display: flex !important;
              align-items: center !important;
            }
            .transfer-user-mobile-select.ant-select .ant-select-selection-placeholder,
            .transfer-user-mobile-select.ant-select .ant-select-selection-item {
              padding-left: 0 !important;
              line-height: 33px !important;
            }
            .transfer-user-mobile-select.ant-select .ant-select-arrow {
              top: 50% !important;
              transform: translateY(-50%) !important;
              right: 12px !important;
            }
          `}
        </style>
      )}
      <h2 style={{marginTop: "-6rem", color: "var(--text-primary)"}}>{t("transferStepsSelectContact")}:</h2>
      <div
        style={{
          marginTop: "-5rem",
          marginLeft: "-1rem",
          paddingBottom: isMobile ? "0" : "3rem",
        }}
      >
        <Select
          style={{
            width: responsiveWidth,
            height: 48,
            borderRadius: 100,
            fontSize: 16,
            border: "transparent",
            color: "var(--text-primary)",
            textAlign: "left",
          }}
          className={isMobile ? "mobile-bank-select transfer-user-mobile-select" : "select-bottom-line"}
          placeholder={t("transferStepsSelectContactOption")}
          value={selectValue}
          onChange={handleSelectChange}
          options={contacts.map(contact => ({
            value: contact.contact_id,
            label: contact.name,
          }))}
        />
      </div>
    </div>
  );
};

TransferUserId.propTypes = {
  selectedContact: PropTypes.object,
  setSelectedContact: PropTypes.func.isRequired,
  setIsNextDisabled: PropTypes.func,
};

export default TransferUserId;
